import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#0F0F0F] to-[#0A0A0A] border-t border-dark-border">
      {/* Desktop: Three-column balanced layout */}
      {/* Mobile: Simplified vertical stack */}
      <div className="max-w-[1400px] mx-auto px-8 md:px-16 lg:px-24 py-12 md:py-16 lg:py-20">
        <div className="flex flex-col gap-8 md:gap-10 lg:flex-row lg:items-center lg:justify-between">
          {/* Brand */}
          <div className="flex-shrink-0">
            <div className="text-white text-lg md:text-xl font-semibold tracking-tight">
              Force Multiplier
            </div>
            <div className="text-gray-500 text-sm md:text-base mt-1">
              ForceM.co
            </div>
          </div>

          {/* Navigation Links - Desktop: horizontal, Mobile: vertical */}
          <nav className="flex flex-col gap-4 md:flex-row md:items-center md:gap-8 lg:gap-10">
            <Link 
              to="/frameworks" 
              className="text-sm md:text-base text-gray-400 hover:text-white transition-colors duration-300 whitespace-nowrap cursor-pointer tap-target"
            >
              Frameworks
            </Link>
            <Link 
              to="/services" 
              className="text-sm md:text-base text-gray-400 hover:text-white transition-colors duration-300 whitespace-nowrap cursor-pointer tap-target"
            >
              Services
            </Link>
            <Link 
              to="/about" 
              className="text-sm md:text-base text-gray-400 hover:text-white transition-colors duration-300 whitespace-nowrap cursor-pointer tap-target"
            >
              About
            </Link>
            <Link 
              to="/apply" 
              className="text-sm md:text-base text-gray-400 hover:text-white transition-colors duration-300 whitespace-nowrap cursor-pointer tap-target"
            >
              Apply
            </Link>
          </nav>

        </div>

        {/* Copyright - Mobile: top spacing, Desktop: integrated */}
        <div className="mt-8 md:mt-10 lg:mt-12 pt-6 md:pt-8 border-t border-dark-border">
          <div className="text-xs md:text-sm text-gray-600 text-center lg:text-left">
            © {new Date().getFullYear()} Force Multiplier. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
